import Dexie, { type Table } from 'dexie';

export interface MapRecord {
  id: string;
  title: string;
  yjsState: Uint8Array;
  updatedAt: number;
}

export class MindMapDB extends Dexie {
  maps!: Table<MapRecord, string>;

  constructor() {
    super('MindMapDB');
    this.version(1).stores({
      maps: 'id, updatedAt',
    });
  }

  async saveMap(id: string, title: string, yjsState: Uint8Array): Promise<void> {
    await this.maps.put({
      id,
      title,
      yjsState,
      updatedAt: Date.now(),
    });
  }

  async loadMap(id: string): Promise<MapRecord | undefined> {
    return await this.maps.get(id);
  }

  async listMaps(): Promise<MapRecord[]> {
    return await this.maps.orderBy('updatedAt').reverse().toArray();
  }

  async deleteMap(id: string): Promise<void> {
    await this.maps.delete(id);
  }
}

export const db = new MindMapDB();
